import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

const DimensionHeaderSkeleton = () => {
  return (
    <Card>
      <CardContent className="flex flex-row items-center gap-4 p-6">
        <div className="grow">
          <div className="flex items-center gap-2">
            <Skeleton className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-white" />
            <Skeleton style={{ width: "160px", height: "36px" }} />
          </div>

          <Skeleton className="mt-3" style={{ width: "70%", height: "24px" }} />
        </div>

        <Skeleton style={{ width: "200px", height: "60px" }} />
      </CardContent>
    </Card>
  );
};

export default DimensionHeaderSkeleton;
